import { render, staticRenderFns } from "./DefaultPanel.vue?vue&type=template&id=4ef9e792&"
import script from "./DefaultPanel.vue?vue&type=script&lang=ts&"
export * from "./DefaultPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports